module.exports = __webpack_public_path__ + "img/box-7.f37f4c05.png";